module.exports = __webpack_public_path__ + "img/ft-resize-minus.fffc7818.svg";